module.exports = __webpack_public_path__ + "img/publipostage.2698ebe4.svg";